
const getTime = () => {
    let sessionData = JSON.parse(sessionStorage?.getItem('timeConfig'))
    let diff = sessionData?.diff || 0
    let newLocaltime = new Date()
    let currentTime = new Date(newLocaltime?.valueOf() + diff)
    return currentTime
}

export const callGolbleData = () => {
    window.getTime = getTime
    return null
}
